import { put, call, all, takeLatest } from 'redux-saga/effects';
import { request } from '../utils/request';
import { API } from '../env';
import { ACTIONCOMMON, ACITONCOPYRIGHT } from '../actionTypes';
import { APICOMMON, APICOPYRIGHT } from '../actionApi';
import { baseinfoSaga } from './admin/baseinfo';
import { albumSaga } from './admin/album';
import { promotionSaga } from './admin/promotion';
import { accountSaga } from './admin/account';
import { homeSaga } from './copyright/home';
import { loginSaga } from './copyright/login';
import { editorrSaga } from './copyright/editor';
import { activitySaga } from './copyright/activity';
import { ucenterSaga } from './copyright/ucenter';
import { crUploadSaga } from './copyright/upload';
import { copyrightBaseinfoSaga } from './copyright/baseinfo';
import { gallerySaga } from './copyright/gallery';
import { idetailSaga } from './copyright/idetail';
import { sharedSaga } from './copyright/shared';
import { PraiseSaga } from './copyright/praise';
import { newsSaga } from './copyright/news';
import { DemoSaga } from './report/demo';
import { getAuth } from '../pages/commonAction';
const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
/**
 * multipart/form-data; boundary=----WebKitFormBoundarypztmzyhg4iSrcAyd
 * file: (binary)
 * token: f8a938b7b7606774dc65813c61037d08
 * weChatId: A2A85401CF46EDA6B35D03196B3DF776
 * albumSn: A2A85401CF46EDA6B35D03196B3DF776
 * uId: 9251481
 */
function* upload(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		contentType: 'multipart/form-data',
		type: 'POST',
		url: API.COMMON_PORXY + APICOMMON.UPLOAD,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getHomepageStatus(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.HOMEPAGESTATUS,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		let { siteSwitch, domainName, companySiteUrl, canEditDomain, activityShowType, wallSwith, vphotoSwitch, moduleName } = result;
		yield put({ type: ACTIONCOMMON.SET_COMMON_HOMEPAGE, payload: { siteSwitch, domainName, companySiteUrl, canEditDomain, activityShowType, wallSwith, vphotoSwitch, moduleName } });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* setHomePageStatus(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'PUT',
		url: API.COMMON_PORXY + APICOMMON.HOMEPAGESTATUS,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACTIONCOMMON.SET_COMMON_HOMEPAGE, payload });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* setHomePageDomainName(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'PUT',
		url: API.COMMON_PORXY + APICOMMON.ALBUMSAHRE,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		payload['canEditDomain'] = 0;
		payload['companySiteUrl'] = result.companySiteUrl;
		yield put({ type: ACTIONCOMMON.SET_COMMON_HOMEPAGE, payload });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getAdminAuth(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.AUTHADMIN,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	console.log('auth', res);
	if (status === 200) {
		yield put({ type: ACTIONCOMMON.SET_COMMON_AUTH, payload });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* copyrightUpload(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		contentType: 'multipart/form-data',
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.UNIONUPLOAD,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
/*
 Alternatively you may use takeLatest.
 Does not allow concurrent fetches of user. If "USER_FETCH_REQUESTED" gets
 dispatched while a fetch is already pending, that pending fetch is cancelled
 and only the latest one will be run.
 */

let commonSaga = [
	takeLatest(ACTIONCOMMON.FETCH_COMMON_UPLOAD, upload),
	takeLatest(ACTIONCOMMON.FETCH_COMMON_HOMEPAGESTATUS, getHomepageStatus),
	takeLatest(ACTIONCOMMON.FETCH_COMMON_SETSHOMEPAGESTATUS, setHomePageStatus),
	takeLatest(ACTIONCOMMON.FETCH_COMMON_SETDOMIANAME, setHomePageDomainName),
	takeLatest(ACTIONCOMMON.FETCH_COMMON_AUTH, getAdminAuth),
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHT_UPLOADIMG, copyrightUpload)
];
export function* adminSaga() {
	yield all([...commonSaga, ...baseinfoSaga, ...albumSaga, ...promotionSaga, ...accountSaga]);
}
export function* CopyrightSaga() {
	yield all([
		...commonSaga,
		...homeSaga,
		...loginSaga,
		...editorrSaga,
		...activitySaga,
		...ucenterSaga,
		...copyrightBaseinfoSaga,
		...crUploadSaga,
		...gallerySaga,
		...idetailSaga,
		...sharedSaga,
		...PraiseSaga,
		...newsSaga
	]);
}
export function* ReportSaga() {
	yield all([...commonSaga, ...DemoSaga]);
}
